<template>
    <div>
        <!-- <div>env: {{ myEnv }}</div> -->
        <b-form-group
            horizontal
            label="Кол-во операций на странице"
            class="mb-1"
            label-for="inputPerPage"
            label-cols-sm="6"
            label-cols-lg="3"
            content-cols-sm="1"
            content-cols-lg="2"
        >
            <b-form-select
                id="inputPerPage"
                :options="numberOfСolumns"
                v-model="perPage"
                @input="changeNumberofPage"
            >
                <template slot="first">
                    <option :value="perPage">{{getPages}}</option>
                </template>
            </b-form-select>
        </b-form-group>

        <optionsAdmin
            v-if="$store.getters.getAdmin"
        />

    </div>

</template>

<script>
import optionsAdmin from './optionsAdmin.vue'
import { newPropertiesStore } from '../store/models'

export default {
  components: {
    optionsAdmin
  },
    data(){
        return {
            perPage: '',
            numberOfСolumns: [],
        }
    },
    async mounted()
    {
        this.$store.dispatch("numberPages/numberOfPages");
    },
    computed: {
        getPages: function(){
            let changeNumber = [10,25,50]
            if (this.$store.getters['numberPages/getnumberOfPages']){
                let pageNumber = this.$store.getters['numberPages/getnumberOfPages']
                let changeNumberfilter = changeNumber.filter(function(value){
                    return value != pageNumber
                })
                this.numberOfСolumns = changeNumberfilter
                return pageNumber
            }
        }
    },
    methods:{
        changeNumberofPage: function(){
                let change = this.perPage
                this.$store.dispatch("numberPages/changeNumberOfPages", change)
        },
    }
}
</script>

<style>

</style>
